import { render, staticRenderFns } from "./detail_refund.vue?vue&type=template&id=81a3b5e4&scoped=true"
import script from "./detail_refund.vue?vue&type=script&lang=js"
export * from "./detail_refund.vue?vue&type=script&lang=js"
import style0 from "./detail_refund.vue?vue&type=style&index=0&id=81a3b5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a3b5e4",
  null
  
)

export default component.exports